window.ProductCards = (function() {
  // Private variables
  let gridElement;
  let productElements = [];
  
  function init(grid, products) {
    console.log('Initializing product cards');
    gridElement = grid;
    productElements = products;
    randomizePositions();
    setupProductInteractions();
  }
  
  function randomizePositions() {
    console.log('Randomizing product positions with enhanced boundary checking');
    
    // Get viewport dimensions
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    // Calculate product card size (matches CSS)
    const cardHeight = viewportHeight * 0.3; // 30vh 
    const cardWidth = cardHeight; // Square cards
    
    // Use a larger safety margin (increased from 3% to 5%)
    const safetyMargin = Math.max(viewportWidth * 0.05, 20); // At least 20px margin
    
    // Define the center area (60% of viewport width/height around center point)
    const centerAreaWidth = viewportWidth * 0.6;
    const centerAreaHeight = viewportHeight * 0.6;
    
    // Calculate center point
    const centerX = viewportWidth / 2;
    const centerY = viewportHeight / 2;
    
    // Calculate the SAFE boundaries with strict margin enforcement
    const safeMinX = Math.max(safetyMargin, centerX - (centerAreaWidth / 2));
    const safeMaxX = Math.min(viewportWidth - cardWidth - safetyMargin, centerX + (centerAreaWidth / 2) - cardWidth);
    const safeMinY = Math.max(safetyMargin, centerY - (centerAreaHeight / 2));
    const safeMaxY = Math.min(viewportHeight - cardHeight - safetyMargin, centerY + (centerAreaHeight / 2) - cardHeight);
    
    // Validate boundaries for edge cases
    if (safeMaxX <= safeMinX || safeMaxY <= safeMinY) {
      console.warn('Viewport too small or center area invalid, using fallback positioning');
      
      // Use absolute positioning to ensure visibility
      const absoluteMinX = safetyMargin;
      const absoluteMaxX = viewportWidth - cardWidth - safetyMargin;
      const absoluteMinY = safetyMargin;
      const absoluteMaxY = viewportHeight - cardHeight - safetyMargin;
      
      // Position each product in a simple grid pattern for fallback
      productElements.forEach((product, index) => {
        const cols = Math.ceil(Math.sqrt(productElements.length));
        const col = index % cols;
        const row = Math.floor(index / cols);
        
        // Calculate grid cell size
        const cellWidth = (absoluteMaxX - absoluteMinX) / cols;
        const cellHeight = (absoluteMaxY - absoluteMinY) / cols;
        
        // Calculate position in center of cell
        const posX = absoluteMinX + (col * cellWidth) + (cellWidth - cardWidth) / 2;
        const posY = absoluteMinY + (row * cellHeight) + (cellHeight - cardHeight) / 2;
        
        // Set position with absolute boundary enforcement
        product.style.left = `${Math.max(absoluteMinX, Math.min(posX, absoluteMaxX))}px`;
        product.style.top = `${Math.max(absoluteMinY, Math.min(posY, absoluteMaxY))}px`;
        
        setupProductImage(product);
      });
      return;
    }
    
    // Create a grid system for better distribution
    const numProducts = productElements.length;
    const gridSize = Math.ceil(Math.sqrt(numProducts * 1.5)); // More cells than products for better spacing
    const cellWidth = (safeMaxX - safeMinX) / gridSize;
    const cellHeight = (safeMaxY - safeMinY) / gridSize;
    
    // Create and shuffle grid cells
    const gridCells = [];
    for (let row = 0; row < gridSize; row++) {
      for (let col = 0; col < gridSize; col++) {
        gridCells.push({row, col});
      }
    }
    
    // Fisher-Yates shuffle
    for (let i = gridCells.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [gridCells[i], gridCells[j]] = [gridCells[j], gridCells[i]];
    }
    
    productElements.forEach((product, index) => {
      if (index >= gridCells.length) return;
      
      const cell = gridCells[index];
      
      // Calculate base position for this cell
      const baseX = safeMinX + (cell.col * cellWidth);
      const baseY = safeMinY + (cell.row * cellHeight);
      
      // Add controlled random variance within the cell (40% of cell size for more controlled positioning)
      const randomOffsetX = (Math.random() * 0.4) * cellWidth;
      const randomOffsetY = (Math.random() * 0.4) * cellHeight;
      
      // Calculate final position
      let posX = baseX + randomOffsetX;
      let posY = baseY + randomOffsetY;
      
      // Absolute boundary enforcement
      posX = Math.max(safeMinX, Math.min(posX, safeMaxX));
      posY = Math.max(safeMinY, Math.min(posY, safeMaxY));
      
      // Set position
      product.style.left = `${posX}px`;
      product.style.top = `${posY}px`;
      
      setupProductImage(product);
    });
  }

  // Extract product image setup to a separate function
  function setupProductImage(product) {
    // Add product card class if not already present
    if (!product.classList.contains('product-card')) {
      product.className = 'product-card';
    }
    
    // Get product title
    const productTitle = product.getAttribute('data-title') || 'Product';
    
    // Create and set up product image if it doesn't exist
    if (!product.querySelector('.product-image')) {
      const productImage = document.createElement('img');
      productImage.src = product.getAttribute('data-image') || '';
      productImage.alt = productTitle;
      productImage.className = 'product-image';
      
      // Add the image as the first child
      product.insertBefore(productImage, product.firstChild);
    }
  }

  function setupProductInteractions() {
    productElements.forEach(product => {
      // Set up size selection and check for sold out sizes
      const sizeCircles = product.querySelectorAll('.size-circle');
      const variantsJsonElement = product.querySelector('.product-variants-json');
      
      // Parse variants data to check availability
      if (variantsJsonElement) {
        try {
          const variants = JSON.parse(variantsJsonElement.textContent);
          const productTitle = product.getAttribute('data-title');
          console.log(`Processing variants for ${productTitle}:`, variants);
          
          // Process each size circle
          sizeCircles.forEach(circle => {
            const sizeValue = circle.getAttribute('data-size');
            
            // Find exact variant match for this specific size
            const matchingVariant = variants.find(v => 
              (v.option1 === sizeValue || v.option2 === sizeValue || v.option3 === sizeValue)
            );
            
            if (matchingVariant) {
              console.log(`${productTitle} - Size ${sizeValue} variant found:`, matchingVariant.title, 
                         `Available: ${matchingVariant.available}`);
              
              // If variant exists but is not available, mark as sold out
              if (!matchingVariant.available) {
                circle.classList.add('sold-out');
                circle.setAttribute('title', 'Sold Out');
                console.log(`${productTitle} - Size ${sizeValue} marked as sold out`);
              }
            } else {
              console.warn(`${productTitle} - No matching variant found for size ${sizeValue}`);
              // If no variant exists for this size, mark as sold out by default
              circle.classList.add('sold-out');
              circle.setAttribute('title', 'Sold Out');
            }
          });
        } catch (error) {
          console.error('Error parsing variant data:', error);
        }
      } else {
        console.warn(`No variants JSON element found for product: ${product.getAttribute('data-title')}`);
      }
      
      // Handle size selection clicks
      sizeCircles.forEach(circle => {
        circle.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Only allow selection of in-stock sizes
          if (this.classList.contains('sold-out')) {
            console.log(`Attempted to select sold out size: ${this.getAttribute('data-size')}`);
            return;
          }
          
          const selectedSize = this.getAttribute('data-size');
          
          // If this circle is already selected, add to cart
          if (this.classList.contains('selected')) {
            console.log(`Adding to cart: ${selectedSize}`);
            
            try {
              const variantsJsonElement = product.querySelector('.product-variants-json');
              if (variantsJsonElement) {
                const variants = JSON.parse(variantsJsonElement.textContent);
                
                // Find the matching variant by size
                const selectedVariant = variants.find(v => 
                  v.option1 === selectedSize || 
                  v.option2 === selectedSize || 
                  v.option3 === selectedSize
                );
                
                if (selectedVariant) {
                  console.log(`Selected variant ID: ${selectedVariant.id}`);
                  console.log(`Selected variant title: ${selectedVariant.title}`);
                  
                  // Use the Cart module to add to cart
                  if (window.Cart && typeof window.Cart.addToCart === 'function') {
                    window.Cart.addToCart(selectedVariant.id, 1)
                      .then(() => {
                        console.log(`Successfully added product ${product.getAttribute('data-title')} with size ${selectedSize} to cart`);
                      })
                      .catch(error => {
                        console.error('Error adding to cart:', error);
                        alert('Could not add item to cart. Please try again.');
                      });
                  } else {
                    console.error('Cart module not available');
                  }
                } else {
                  console.error(`Couldn't find matching variant for size: ${selectedSize}`);
                }
              }
            } catch (error) {
              console.error('Error processing variant data:', error);
            }
            
            // Simple animation for confirmation
            this.style.transform = 'rotate(-180deg)';
            setTimeout(() => {
              this.style.transform = '';
              this.classList.remove('selected');
              this.innerHTML = this.getAttribute('data-size');
            }, 500);
            
            return;
          }
          
          // Clear other selections
          sizeCircles.forEach(c => {
            c.classList.remove('selected');
            c.innerHTML = c.getAttribute('data-size');
          });
          
          // Store selected size on the product
          product.setAttribute('data-selected-size', selectedSize);
          console.log(`Selected size: ${selectedSize}`);
          
          // Transform this circle into an add-cart button
          this.classList.add('selected');
          // Save original text to restore later if needed
          this.setAttribute('data-original-text', this.textContent);
          // Change to plus icon
          this.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
        });
      });
      
      // Handle click for product details - using a separate event listener to avoid conflicts with dragging
      product.addEventListener('click', handleProductClick);
    });
    
    // Close any open popups when clicking outside
    document.addEventListener('click', function(e) {
      // For product cards
      if (!e.target.closest('.product-card')) {
        // Hide all product option popups
        document.querySelectorAll('.product-options-popup.active').forEach(popup => {
          popup.classList.remove('active');
        });
      }
      
      // For 3D model
      if (!e.target.closest('#glb-model-container')) {
        // Hide teleport popup
        document.querySelectorAll('.teleport-popup.active').forEach(popup => {
          popup.classList.remove('active');
        });
      }
    });
  }
  
  /**
   * Handle product click (for showing product details)
   */
  function handleProductClick(e) {
    const product = e.currentTarget;
    
    // If we were dragging, don't treat as a click
    // This check uses the data-dragging attribute from draggable.js
    if (product.getAttribute('data-dragging') === 'true') {
      console.log('Ignoring click because we were dragging');
      return;
    }
    
    console.log('Product clicked (not dragged)');
    
    // Toggle options popup
    const optionsPopup = product.querySelector('.product-options-popup');
    if (optionsPopup) {
      // Check if already active
      if (optionsPopup.classList.contains('active')) {
        // If active, show product details
        const productId = product.getAttribute('data-product-id');
        if (window.ProductFocus && typeof window.ProductFocus.showProduct === 'function') {
          window.ProductFocus.showProduct(productId, product);
        }
      } else {
        // If not active, show options
        optionsPopup.classList.add('active');
        
        // Hide other product options that might be open
        document.querySelectorAll('.product-options-popup.active').forEach(popup => {
          if (popup !== optionsPopup) {
            popup.classList.remove('active');
          }
        });
      }
    }
  }

  // Public API
  return {
    init: init,
    randomizePositions: randomizePositions,
    setupProductInteractions: setupProductInteractions
  };
})();